import { useQuery } from '@tanstack/react-query';
import { mediaClient } from '@/data/@clients';
import type {
  CoursesByTrail,
  Trail,
} from '@/data/corporate-university/interfaces';

export const useTrailsIndex = () => {
  const { data, isLoading, error } = useQuery<Trail[]>({
    queryKey: ['trails'],
    queryFn: () => mediaClient.get('/trails'),
  });

  return { trails: data, isLoading, error };
};

export const useShowTrailById = (id: string) => {
  const { data, isLoading, error } = useQuery<CoursesByTrail>({
    queryKey: ['trail', id],
    queryFn: () => mediaClient.get(`/trails/${id}`),
    enabled: !!id,
  });

  return { trail: data, isLoading, error };
};
